// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled from 'styled-components';

import FitHeight from './FitHeight';

const StyledFitHeight = styled(FitHeight)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrap = styled.div`
  width: 100%;
  text-align: center;
`;

const WrapImg = styled.div`
  margin: 0 auto;
  width: 10em;
  height: 10em;
  padding: 0.6em;
  border-radius: 50%;
  border: solid 3px ${({ theme }) => theme.grids.colors.darkgrey4};
`;

const Img = styled.div`
  background-image: url(${({ $image }) => $image});
  background-size: 100% auto;
  background-position: center;
  border-radius: 50%;
  width: 100%;
  height: 100%;
`;

export const P = styled.p`
  color: ${({ theme }) => theme.grids.colors.middlegrey3};
  font-family: BettingPoliticaBold, sans-serif;
  margin-top: 1em;
  margin-bottom: 1em;
`;

export const Bold = styled.p`
  font-weight: 800;
  color: #fff;
  margin-top: 1em;
  margin-bottom: 1em;
`;

type Props = {
  className?: string;
  children: Node;
  imgPath?: string;
  isDisabledFit?: boolean;
};

const EmptyView = ({ className, children, imgPath, isDisabledFit = false }: Props) => {
  return (
    <StyledFitHeight className={className} isDisabled={isDisabledFit}>
      <Wrap>
        {imgPath && (
          <WrapImg>
            <Img $image={imgPath} />
          </WrapImg>
        )}
        {children}
      </Wrap>
    </StyledFitHeight>
  );
};

export default EmptyView;
